import React from 'react';
import { translate } from '@utils/i18n';
import './StatusCards.css';
const namespace = 'features.ai_to_review_inspections.index.status_cards';
function StatusCards({ statusCounts }) {
    const cards = [
        {
            title: translate('not_started', { namespace }),
            count: (statusCounts === null || statusCounts === void 0 ? void 0 : statusCounts.not_started) || 0,
            className: 'status-card--not-started',
            icon: 'fa-light fa-play'
        },
        {
            title: translate('in_progress', { namespace }),
            count: (statusCounts === null || statusCounts === void 0 ? void 0 : statusCounts.in_progress) || 0,
            className: 'status-card--in-progress',
            icon: 'fa-light fa-spinner'
        },
        {
            title: translate('sent_for_correction', { namespace }),
            count: (statusCounts === null || statusCounts === void 0 ? void 0 : statusCounts.sent_for_correction) || 0,
            className: 'status-card--sent-correction',
            icon: 'fa-light fa-arrow-rotate-left'
        }
    ];
    return (React.createElement("div", { className: "status-cards-container" },
        React.createElement("div", { className: "status-cards" }, cards.map((card, index) => (React.createElement("div", { key: index, className: `status-card ${card.className}` },
            React.createElement("div", { className: "status-card__icon" },
                React.createElement("i", { className: card.icon })),
            React.createElement("div", { className: "status-card__content" },
                React.createElement("div", { className: "status-card__count" }, card.count),
                React.createElement("div", { className: "status-card__title" }, card.title))))))));
}
export default StatusCards;
